import React from "react";

const GameCard = ({ item, handleSelect, isSelected, filterOption }) => {
    const isSelectedCard = (array, object) => {
        return array?.some((g) => g.gameId === object.gameId);
    };
    const selected = filterOption !== "all" && isSelectedCard(isSelected, { gameId: item.gameId });

    return (
        <div>
            <div
                className={
                    selected
                        ? "giftcard_voucher_box selected_voucher overhidden"
                        : "giftcard_voucher_box"
                }
            >

                {filterOption === "all" ? "" : selected ? <span className="giftcard_selected_check"><i class="fa-solid fa-check fa-xl"></i></span> : ""}
                <div className="game_imagebox" onClick={(e) => {
                    e.preventDefault();
                    if (filterOption !== "all") {
                        handleSelect(item.gameId, selected ? "Unselect" : "Select", item);
                    }
                }} >
                    <img src={item?.imageUrl} alt="" />
                    <div className={filterOption === "all" ? "" : "gc_overlay"}>
                        <div className={filterOption === "all" ? "" : "gc_overlay_box"}>
                            <span className={filterOption === "all" ? "" : "hover_text"}>
                                {filterOption === "all" ? "" : selected ? "Click to Unselect" : "Click to Select"}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="row giftcard_voucher_details">
                    <div className="giftcard_voucher_title">

                        <h5>{item?.gameName}</h5>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GameCard;
